import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_FeildActivity_Interface, FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ExpirationService } from 'src/app/Service/Expiration/Expiration.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-ExpirationList',
  templateUrl: './ExpirationList.component.html',
  styleUrls: ['./ExpirationList.component.scss']
})
export class ExpirationListComponent implements OnInit {
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private Expiration_Service:ExpirationService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_Expiration:Array<FeildActivity_Interface>=[]
  Data_Seleted_Delete:FeildActivity_Interface=Empty_FeildActivity_Interface()

  ngOnInit() {

    this.Nav_Service.CheckValidPage(19).subscribe(
      data=>{
        this.ReadData_Expiration()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Expiration(){
    this.Procssing=true
    this.Expiration_Service.GetRecord().subscribe(
      data=>{
        this.DataList_Expiration=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:FeildActivity_Interface){
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.Expiration_Service.DeleteExpiration(item.id).subscribe(
      data=>{
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("غیرفعال شد")
        else
          this.Alertify_Service.SuccessMessage("فعال شد")
        this.ReadData_Expiration()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Defaultt(item:FeildActivity_Interface){
    item.DeletingProccess=true
    this.Expiration_Service.DefaulttExpiration(item.id).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("پیش فرض شد")
        this.ReadData_Expiration()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

}
